import * as React from 'react';
import { InformationIcon } from './icon/information-icon';
import styles from './information-panel.module.scss';

type InformationPanelProps = {
  children: React.ReactNode;
};

export const InformationPanel = ({ children }: InformationPanelProps) => {
  return (
    <div className="bg-white py-6 px-6 sm:px-8 shadow-lg rounded-lg max-w-xl mx-auto relative border-4 border-blue-700">
      <InformationIcon
        width={75}
        className={`hidden sm:block ${styles.icon}`}
      />
      {children}
    </div>
  );
};
